import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { HelpOutline as HelpIcon } from '@mui/icons-material';

import { IconButton, Tooltip, Zoom } from '@mui/material';

import { getHelpList, getHelpListSuccess } from '../../state/help/Help.actions';
import Constants from '../../constants/Constants';
import './OnlineHelp.css';

class OnlineHelp extends Component {
  componentDidMount() {
    this.props._getHelpList();
  }

  render() {
    const iconStyle = this.props.isHelpRoot ? 'large' : 'default';
    const helpPage = this.props.helpTag
      ? this.props.helpMap[this.props.helpTag] || '?' + this.props.helpTag
      : this.props.href;
    const helpPath = `${Constants.HELP_BASE_URL}${helpPage}`;
    return (
      <Tooltip disableInteractive TransitionComponent={Zoom} title="Online help">
        <IconButton
          size="large"
          data-qa="OnlineHelp"
          href={helpPath}
          rel="noopener noreferrer"
          target="_blank"
          style={{ width: '', height: '', padding: 0 }}
        >
          <HelpIcon fontSize={iconStyle} />
        </IconButton>
      </Tooltip>
    );
  }
}

OnlineHelp.propTypes = {
  helpTag: PropTypes.string,
  href: PropTypes.string,
  isHelpRoot: PropTypes.bool,
};

OnlineHelp.defaultProps = {
  helpTag: null,
  href: 'index.html',
  isHelpRoot: false,
};

const mapStateToProps = (state) => ({
  helpMap: state.help ? state.help.helpTagsToRelativeUrl : {},
});

const mapDispatchToProps = (dispatch) => ({
  _getHelpList: () => {
    return getHelpList()
      .then((res) => dispatch(getHelpListSuccess(res.body)))
      .catch((err) => console.log(err));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OnlineHelp);
